import { SectionLayout } from '@nucleus/types/web/section-data';
import { SectionConfigBuilder } from '../ThemeConfigBuilder';
import { body, byline, headline, overline } from '../fields/fields';

export default new SectionConfigBuilder()
  .setContext('picker', {
    label: 'Post Header',
    description: 'Post header display',
    icon: 'Post',
  })
  .setContext('editor', {
    label: 'Post Header Section',
    description: '',
    icon: 'Post',
  })
  .addLayout('layout4', (layout) => {
    layout
      .setIcon('LongText')
      .setAvailableSectionLayouts([SectionLayout.Full, SectionLayout.Constrained])
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setActions(0);
      })
      .addBlock((block) => {
        block.setText([overline, headline, byline, body]);
        block.setMedia(0);
        block.setActions(Infinity);
      });
  })
  .build();
